import { CommonPaypalButtonProps } from 'common/components/entities/paypal-rest-button'
import {
  TwoStepPaymentFormStep,
  TwoStepPaymentFormStepFooter,
} from 'common/components/entities/two-step-payment-form'
import paymentMethodTypes from 'common/constants/paymentMethodTypes'
import { mercadoCreditCardTypes } from 'common/enums/PaymentMethodEnum'
import { TwoStepPaymentFormStepInterface } from 'common/types/entities/two-step-payment-form-interface'
import BaseNodeChildren from 'publisher/components/ChildrenEntities'
import { PaypalRestPaymentButton } from 'publisher/components/entities/PaymentButtonNew/paypal-rest-button'
import { isStripePaymentMethod } from 'publisher/components/entities/PaymentMethod/utils/paymentCreditCardUtils'
import { TwoStepCommonPaymentButton } from 'publisher/components/entities/two-step-payment-form/two-step-common-payment-button'
import { usePaymentHandlerByProvider } from 'publisher/hooks/payment/use-payment-handler-by-provider'
import usePayment, { selectors } from 'publisher/hooks/usePayment'
import React, { useEffect, useRef } from 'react'
import { Helmet } from 'react-helmet'

const { PAYPAL_REST } = paymentMethodTypes

export interface PaymentStepProps {
  entity: TwoStepPaymentFormStepInterface
  color: string
  mobileColor?: string
  backgroundColor?: string
  mobileBackgroundColor?: string
  paypal?: CommonPaypalButtonProps
}

export const TwoStepPaymentFormPaymentStep = ({
  entity,
  color,
  mobileColor,
  backgroundColor,
  mobileBackgroundColor,
  paypal,
}: PaymentStepProps) => {
  const paymentMethod = usePayment(selectors.getActivePaymentMethod)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    ref?.current?.scrollIntoView({
      block: 'nearest',
      behavior: 'smooth',
    })
  }, [])

  const paymentHandler = usePaymentHandlerByProvider(paymentMethod)

  return (
    <TwoStepPaymentFormStep ref={ref}>
      {isStripePaymentMethod(paymentMethod) && (
        <Helmet
          link={[
            {
              rel: 'stylesheet',
              href: `${process.env.CLOUDFRONT_PUBLISHER_ASSETS_HOST}/assets/css/stripe.css?ver=1.2`,
            },
          ]}
        />
      )}
      <BaseNodeChildren childIds={entity.childIds} />
      {paymentMethod === PAYPAL_REST ? (
        <PaypalRestPaymentButton
          //@ts-ignore
          entity={entity}
          backgroundColor={paypal?.backgroundColor}
        />
      ) : (
        paymentHandler && (
          <TwoStepCommonPaymentButton
            key={paymentMethod}
            entity={entity}
            color={color}
            mobileColor={mobileColor}
            backgroundColor={backgroundColor}
            mobileBackgroundColor={mobileBackgroundColor}
            text={entity.buttonText}
            subText={entity.buttonSubText}
            paymentHandler={paymentHandler}
            isMercadoPagoCardMethod={mercadoCreditCardTypes.includes(
              paymentMethod,
            )}
          />
        )
      )}
      {entity.footerText && (
        <TwoStepPaymentFormStepFooter>
          {entity.footerText}
        </TwoStepPaymentFormStepFooter>
      )}
    </TwoStepPaymentFormStep>
  )
}
